<template>
    <div style="padding-top: 80px">
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="!showAdd">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Realizar Encuesta</p>

            </v-card-title>
            <v-form ref="form">
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" sm="6" md="4">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Concepto</span>
                                <v-select outlined dense :items="conceptosArray" v-model="datos.tipoencuesta"
                                    no-data-text="Seleccione el Tipo" item-text="egdesc" item-value="egid"
                                    placeholder="Seleccione una opción" :rules="ruleSelect" return-object>

                                </v-select>
                            </div>

                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Reporte</span>
                                <v-text-field v-model="datos.nrreporte" outlined dense :rules="rulesInputs"
                                    maxlength="12" @keypress="ruleNumber($event, datos.nrreporte)"
                                    @keydown.enter.prevent="nuevaEncuesta()"></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Índice</span>
                                <v-text-field v-model="datos.svindice" outlined dense :rules="rulesInputs" maxlength="3"
                                    @keypress="ruleNumber($event, datos.svindice)"
                                    @keydown.enter.prevent="nuevaEncuesta()"></v-text-field>
                            </div>
                        </v-col>
                    </v-row>
                    <v-col md="12">
                        <v-row justify="center">

                            <v-btn class="ma-2" color="primary" title="Enviar" @click="nuevaEncuesta()">
                                <span style='color: white;'>Enviar</span>
                            </v-btn>
                        </v-row>
                    </v-col>

                </v-card-text>


            </v-form>
        </v-card>
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="showAdd">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Cambio de estatus</p>

            </v-card-title>
            <v-form ref="form2">
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" sm="6" md="4">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Estatus</span>
                                <v-select outlined dense :items="estatusArray" v-model="estatus"
                                          no-data-text="Seleccione motivo" item-text="esdesc" item-value="esid"
                                          placeholder="Seleccione una opción" :rules="ruleSelect2">

                                </v-select>
                            </div>
                            <div class="mt-4" v-if="estatus === 59">
                                <span style="font-weight: bold;">Motivo:</span>
                                <v-textarea v-model="motivoNA" :counter="$store.state.maxLengthComentarios"
                                            :rules="rulestextareaM" 
                                            outlined :maxlength="$store.state.maxLengthComentarios"
                                            required name="input-7-4"
                                            v-on:blur="motivoNA = motivoNA != null ? motivoNA.trim() : null"></v-textarea>
                            </div>

                        </v-col>
                    </v-row>
                    <v-col md="12">
                        <v-row justify="center">

                            <v-btn class="ma-2" color="primary" title="Guardar" @click="guardarEstatus()"
                                :disabled="disabledSaveGuardar">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>
                        </v-row>
                    </v-col>

                </v-card-text>


            </v-form>
        </v-card>

        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="showAdd">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;">Realizar Encuesta</p>

            </v-card-title>
            <v-card-text v-if="!loadingModal">
                <div class="spinner-container text-center">
                    <v-progress-circular indeterminate color="green"></v-progress-circular>
                </div>
                <br />
            </v-card-text>
            <v-form ref="form3" v-if="loadingModal" v-model="valid" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12">
                            <v-card-text style="background-color:#10ac84">
                                <v-row align="center" justify="end">
                                    <v-col cols="1">
                                        <v-btn title="Cancelar Encuesta" color="red" @click="cancelarEncuesta()"
                                            style="height: 30px; min-width: 5px; width: 70%;">
                                            <v-icon color="white">mdi-close</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>

                                <h3 class="text-center" style="color: white">Realizar {{ datos.tipoencuesta.egdesc }}</h3>
                                <h5 class="text-center" style="color: white">Número de reporte
                                    {{ datos.nrreporte }}-{{ datos.svindice }}</h5>
                            </v-card-text>
                            <v-card-text>
                                <div id="idScript" class="text text-center" style="font-size: 15px"></div>

                                <div v-for="(item, index) in formulariopreguntas" :key="index">
                                    <center v-if="(index > 0)">
                                        <br />
                                        <br />
                                    </center>
                                    <center>
                                        <v-card style="border: 5px solid #E0E0E0">
                                            <br />
                                            <span style="font-size:19px;">{{ item.evorden === 3 && preguntaRadio ? preguntaRadio : item.evpregunta }}</span>

                                            <v-col cols="10" justify="center">

                                                <v-row justify="center" align-content="center"
                                                    v-if="item.trdesc == 'Univaluada'">
                                                    <v-radio-group v-model="valueradio[index].rpid" :rules="rulesInputs"
                                                        required color="black" row>

                                                        <v-radio :value="item1.rpid" :label="item1.rpdesc"
                                                            @change="changeradio(item, item1)"
                                                            v-for="(item1, index1) in formularioRespuestas[index]"
                                                            :key="index1"></v-radio>


                                                    </v-radio-group>
                                                </v-row>
                                                <div
                                                    v-if="item.trdesc == 'Univaluada-Condicion' || item.trdesc == 'Univaluada-Porque'">
                                                    <v-row justify="center" align-content="center">
                                                        <v-radio-group v-model="valueradio[index].rpid"
                                                            :rules="rulesInputs" required row>

                                                            <v-radio :value="item1.rpid" :label="item1.rpdesc"
                                                                @change="changeradio(item, item1)"
                                                                v-for="(item1, index1) in formularioRespuestas[index]"
                                                                :key="index1"></v-radio>


                                                        </v-radio-group>
                                                    </v-row>
                                                    <v-row justify="center" align-content="center"
                                                        v-if="valueradio[index].rpid != null && valueradio[index].rpid != ''">
                                                        <v-col md="6">
                                                            <span style="font-size:24px">Sugerencia:</span>
                                                            <br />
                                                            <v-textarea :counter="500"
                                                                :maxlength="$store.state.maxLengthComentarios"
                                                                :rules="rulestextarea" outlined
                                                                v-model="valueradio[index].evasugerencia"
                                                                v-on:blur="valueradio[index].evasugerencia = valueradio[index].evasugerencia != null ? valueradio[index].evasugerencia.trim() : null"
                                                                required></v-textarea>

                                                        </v-col>


                                                    </v-row>


                                                </div>

                                                <v-row justify="center" align-content="center"
                                                    v-if="item.trdesc == 'Abierta'">

                                                    <v-col md="6">
                                                        <v-textarea  :counter="500"
                                                                    :maxlength="$store.state.maxLengthComentarios"
                                                                    :rules="rulestextareaF" outlined
                                                                    v-model="valueradio[index].evaporque"
                                                                    v-on:blur="valueradio[index].evaporque = valueradio[index].evaporque != null ? valueradio[index].evaporque.trim() : null"
                                                                    required name="input-7-4"></v-textarea>

                                                    </v-col>

                                                </v-row>
                                                <br />
                                            </v-col>


                                        </v-card>


                                    </center>




                                </div>



                                <br />
                                <div id="idScript2" class="text text-center" style="font-size: 15px"></div>

                            </v-card-text>

                        </v-col>
                    </v-row>
                    <v-row justify="center" v-if="showMotivo">
                        <v-col cols="12" sm="6" md="4">
                            <div class="mt-2">
                                <span style="font-weight: bold;">Seleccione el Motivo de No Conformidad</span>
                                <v-select outlined dense :items="motivoArray" v-model="motivo"
                                    no-data-text="Seleccione motivo" item-text="cnconcepto" item-value="cnid"
                                    placeholder="Seleccione una opción" :rules="ruleSelect3">

                                </v-select>
                            </div>

                        </v-col>
                    </v-row>
                    <v-col md="12">
                        <v-row justify="center">

                            <v-btn class="ma-2" color="primary" title="Guardar" @click="guardarEncuesta()"
                                :disabled="disabledSaveGuardar">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>
                            <br />
                        </v-row>
                    </v-col>

                </v-card-text>


            </v-form>
        </v-card>



    </div>
</template>




<script>
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import Calidad from "@/services/Calidad/Calidad.service.js";
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
export default {
    title() {
        return this.$route.meta.title
    },
    components: {
    },
    data() {
        return {
            color: 'indigo',
            variants: 'tonal',
            motivoArray: [],
            motivo: '',
            showMotivo: false,


            loadingModal: false,
            showAdd: false,
            estatusArray: [],
            conceptosArray: [],
            datos: {
                tipoencuesta: '',
                nrreporte: '',
                svindice: '1'

            },
            motivoNA: '',//descripcion del estatus No Aplica
            estatus: '',
            ruleSelect: [(v) => !!v || "Campo requerido"],
            ruleSelect2: [(v) => !!v || "Campo requerido"],
            ruleSelect3: [(v) => !!v || "Campo requerido"],
            rulesInputs: [(v) => !!v || "Campo requerido"],
            formulariopreguntas: [],
            formularioRespuestas: [],
            valid: true,
            valueradio: [],
            formulariopreguntastemp: [],
            preguntaRadio: '',
            rulestextarea: [
                v => {
                    if (v == null || v == '') {
                        return true
                    }
                    else {
                        // return 'Mínimo 12 Carácteres'

                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                }
            ],
            rulestextareaF: [
                v => {
                    if (v == null || v == '') {
                        return 'Campo requerido'
                    }
                    else {
                        // return 'Mínimo 12 Carácteres'

                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > 500) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                }
            ],
            rulestextareaM: [
                v => {
                    if (v == null || v == '') {
                        return 'Campo requerido'
                    }
                    else {
                        if (v.length < 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios +"Carácteres"
                        }
                        else
                            return true
                    }
                }
            ],

            disabledSaveGuardar: false,
            conteo: 0,
            preguntas: [],



        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
    },
    watch: {
        'motivo'(val) {
            if (this.valueradio.length > 0) {
                if (this.datos.tipoencuesta.egid == 12) {
                    this.valueradio[1].motivo = val;
                }
                if (this.datos.tipoencuesta.egid == 14) {
                    this.valueradio[0].motivo = val;
                }
               
            }

        },
        'formulariopreguntastemp'(val) {
            if (val.length > 0) {
                let v = this;
                val.forEach(function (key, value) {
                    v.valueradio.push({ 'evid': key.evid, 'rpid': null, 'evaporque': null, 'evasugerencia': null, 'motivo': null });
                });
            }
        },
        //Cambio de estatus
        estatus(newVal) {
            if (newVal !== 59) {
                this.motivoNA = ""; 
            }
        }

    },
    methods: {
        async changeradio(itemP, itemR) {
            let calificacion = parseInt(itemR.rpdesc);

            if ((itemP.evorden == 2 && this.datos.tipoencuesta.egid == 12) || this.datos.tipoencuesta.egid == 14) {
                let data = await Calidad.ObtenerPreguntaRadio(this, calificacion);
                this.preguntaRadio = data[0].pregunta;

                if (calificacion <= 6) {
                    this.showMotivo = true;
                    this.motivoArray = await Calidad.ObtenerListadoMotivo(this);
                } else {
                    this.showMotivo = false;
                    this.motivo = '';
                }
            }
        },



        cancelarEncuesta() {
            this.estatus = '';
            this.$refs.form2.resetValidation();
            setTimeout(() => {


                this.conteo = 0;
                this.motivo = '';
                this.showMotivo = false;

                this.loadingModal = false;
                this.showAdd = false;
                this.estatusArray = [];

                this.datos.tipoencuesta = '';
                this.datos.nrreporte = '';
                this.datos.svindice = '1';

                this.valueradio = [];



                document.getElementById("idScript").innerHTML = "";
                document.getElementById("idScript2").innerHTML = "";
            }, 500);

        },
        async guardarEncuesta() {
            this.disabledSaveGuardar = true;
            this.$refs.form3.validate();
            if (this.$refs.form3.validate()) {
                this.$swal({
                    position: 'center',
                    title: 'Guardando Encuesta...',
                    text: 'Espere un momento por favor',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        this.$swal.showLoading();
                    }
                });

                await Calidad.guardarEncuesta(this).then(response => {
                    this.$swal.close();
                    if (response == 'encuestaCorrecta') {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Encuesta realizada correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 5000,
                        }).then(async () => {
                            this.disabledSaveGuardar = false;
                            this.cancelarEncuesta();

                        });

                    }
                    else if (response == 'errorEncuesta') {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Advertencia',
                            text: 'La encuesta no se ha realizado correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 5000,
                        }).then(async () => {
                            this.disabledSaveGuardar = false;
                            this.cancelarEncuesta();

                        });

                    }
                    else if (response == 'errorCliente') {
                        this.$swal({
                            position: 'center',
                            icon: 'warning',
                            title: 'Advertencia',
                            text: 'La encuesta ya la realizó el usuario',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 5000,
                        }).then(async () => {
                            this.disabledSaveGuardar = false;
                            this.cancelarEncuesta();

                        });
                    }
                });

            }
            else {
                this.disabledSaveGuardar = false;
            }
        },
        async guardarEstatus() {
            this.disabledSaveGuardar = true;
            this.$refs.form2.validate();
            if (this.$refs.form2.validate()) {
                await Calidad.guardarEstatus(this).then(response => {
                    if (response) {
                        this.$swal({
                            position: 'center',
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Estatus guardado correctamente',
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            timer: 5000,
                        }).then(async () => {
                            this.cancelarEncuesta();
                        });

                    }
                    else {
                        this.$swal({
                            position: 'center',
                            icon: 'error',
                            title: 'Error',
                            text: 'El estatus no se guardó correctamente, favor de avisar a desarrollo@ausa.com.mx',
                            showConfirmButton: true,
                            allowOutsideClick: false
                        }).then(async () => {
                            this.cancelarEncuesta();

                        });
                    }

                });

            }
            else {
                this.disabledSaveGuardar = false;
            }
        },
        ruleNumber: function ($event, value) {

            if (value == '' || value == null) {
                if ($event.charCode >= 49 && $event.charCode <= 57) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }
            }
            else {
                if (($event.charCode >= 48 && $event.charCode <= 57)) {
                    return true;
                }
                else {
                    $event.preventDefault();
                }

            }
        },
        async nuevaEncuesta() {

            this.$refs.form.validate();

            if (this.$refs.form.validate() && this.conteo == 0) {
                this.conteo = 1;
                let response = await Calidad.verificarEncuesta(this);
                this.disabledSaveGuardar = false;
                if (response) {
                    this.showAdd = true;
                    let responseEncuesta = await Calidad.ObtenerListadoEstatus(this);
                    this.estatusArray = responseEncuesta;

                    let response2 = await Calidad.ObtenerPreguntasEncuesta(this);

                    this.formulariopreguntastemp = response2;
                    this.formulariopreguntas = response2;


                    let response3 = await Calidad.ObtenerRespuestasEncuesta2(this);
                    this.formularioRespuestas = response3;
                    this.loadingModal = true;


                    let response1 = await Calidad.ObtenerLeyendasEncuesta(this);
                    document.getElementById("idScript").innerHTML = response1.egscript;
                    document.getElementById("idScript2").innerHTML = response1.egscript2;



                }
                else {
                    let responseE = await Calidad.obtenerEstatusEncuesta(this);

                    this.$swal({
                        position: 'center',
                        icon: 'warning',
                        title: 'Advertencia',
                        html: responseE,
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        timer: 5000,
                    }).then(async () => {
                        this.conteo = 0;
                        this.datos.tipoencuesta = '';
                        this.datos.nrreporte = '';
                        this.datos.svindice = '1';
                        this.$refs.form.resetValidation();
                    });

                }



            }
        }


    },
        async mounted() {        

        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "12"//modulo de calidad
        ).then((response) => {
            if (response.data.length == 0) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                return
            }
        });

        Calidad.ObtenerGruposEncuestas(this);



    }
}

</script>